export const EXCMAGREEMENTDEVICE_DELETE_RESET = 'EXCMAGREEMENTDEVICE_DELETE_RESET'
export const EXCMAGREEMENTDEVICE_DELETE_SET_ERROR = 'EXCMAGREEMENTDEVICE_DELETE_SET_ERROR'
export const EXCMAGREEMENTDEVICE_DELETE_SET_DELETED = 'EXCMAGREEMENTDEVICE_DELETE_SET_DELETED'
export const EXCMAGREEMENTDEVICE_DELETE_TOGGLE_LOADING = 'EXCMAGREEMENTDEVICE_DELETE_TOGGLE_LOADING'
